import { useUserPreferences } from "@/entities/user/model/UserPreferencesContext";

const locales = ["pt-PT", "en"] as const;
type Locale = (typeof locales)[number];

const localeLabels: Record<Locale, string> = {
  "pt-PT": "PT",
  en: "EN",
};

const localeFullLabels: Record<Locale, string> = {
  "pt-PT": "Português",
  en: "English",
};

export function LanguageSwitcher() {
  const { preferences, updatePreference } = useUserPreferences();
  const locale = (preferences.language ?? "pt-PT") as Locale;

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const nextLocale = event.target.value as Locale;
    void updatePreference("language", nextLocale);
  }

  return (
    <select
      value={locale}
      onChange={handleChange}
      title={localeFullLabels[locale]}
      aria-label="Selecionar idioma"
      className="rounded-md border border-dark_green bg-transparent px-2 py-1 text-xs font-semibold
                 text-dark_green cursor-pointer outline-none
                 hover:border-yellow hover:text-dark_green
                 focus:ring-2 focus:ring-yellow focus:ring-offset-1
                 transition-colors duration-base"
    >
      {locales.map((loc) => (
        <option key={loc} value={loc} className="bg-white dark:bg-night_surface text-dark_green">
          {localeLabels[loc]}
        </option>
      ))}
    </select>
  );
}
